import { measuredCookieReduxKey } from './constants';

export type ServerCookies = {
  [k: string]: string;
};
export type CookieDimType = 'width' | 'height' | 'both';

export type Dims = {
  width: number;
  height: number;
};

export type MeasuredCookieConnectorOwnProps = {
  cookieType?: MeasuredCookieType;
  cookieDim?: CookieDimType;
};

export enum MeasuredCookieType {
  USER_PROFILE_GALLECTION_CONTENT = 0,
  USER_PROFILE_GALLECTION_GRIDBLOCK = 1,
  USER_PROFILE_SHOP = 2,
  USER_PROFILE_FEATURED = 3,
  USER_PROFILE_POSTS = 4,
  MESSAGECENTRE_WATCH = 5,
  DEVIATION_ARTSTAGE = 6,
  BROWSE = 7,
  DEVIATION_SIDEBAR = 8,
  DAILY_DEVIATIONS = 9,
  FEATURED_DEVIATION = 10,
  USER_PROFILE_CUSTOM = 11,
  SCREEN_WIDTH = 12,
  SLIDER = 13,
  PROTECT = 16,
  GALLECTION_EXPLORER = 17,
  GALLECTION_MANAGER = 18,
  DEVIATION_PAGE_RECOMMENDED_TORPEDO = 19,
  TOPICS_STRIP = 20,
  BROWSE_POST_FEED = 21,
  FEATURED_POST = 22,
  NOTIFICATION_MOBILE_COVER_IMAGE = 23,
  MOBILE_POPUP_CONTENT_WIDTH = 24,
  USER_PROFILE_CUSTOM_LEFT = 25,
  USER_PROFILE_CUSTOM_TOP_1 = 26,
  USER_PROFILE_CUSTOM_TOP_2 = 27,
  USER_PROFILE_CUSTOM_TOP_3 = 28,
  DREAMUP = 29,
  DREAMUP_INFO_MODAL = 30,
  LLAMA_FARM_LEFT = 31,
  LLAMA_FARM_RIGHT = 32,
  SUBMIT_SHOP_THUMB = 33,
  DEVIATION_SIDEBAR_PROMO = 34,
  SELL_YOUR_ART_SHOP_STRIP = 35,
  SELL_YOUR_ART_MOBILE_SWIPE_CARD = 36,
  ANON_DREAMUP_LANDING_TORPEDO = 37,
  EDTIOR_DEV_DESCRIPTION = 38,
  DEVIATION_DESCRIPTION = 39,
  USER_ABOUT = 40,
  EDITOR_STATUS = 41,
  EDITOR_POLL = 42,
  USER_PROFILE_CUSTOM_RIGHT = 43,
  USER_DONATIONS = 44,
  COMMISSION = 45,
  EDITOR_JOURNAL = 46,
  EDITOR_LITERATURE = 47,
  GROUP_ABOUT = 48,
  COMMENT_RENDERER = 49,
  STASH_FOLDER_TORPEDO = 50,
  STASH_FOLDER_CARD = 51,
  ATTACHMENT_CAPTION = 52,
  DEVIATION_MULTI_IMAGE_SCROLL = 53,
  DEVIATION_MULTI_IMAGE_CAROUSEL = 54,
  STUDIO_GRID = 55,
  GALLECTION_FOLDER = 56,
  STUDIO_SUBFOLDER_CARD = 57,
  GALLECTION_FOLDER_PAYWALL = 58,
  BROWSE_MASONRY = 59,
}

export interface MeasuredCookieStateSlice {
  [k: number]: number | [number, number];
}
export interface MeasuredCookieState {
  [measuredCookieReduxKey]?: MeasuredCookieStateSlice;
}
